export default "__VITE_ASSET__DK$41tEZ__"